module.exports = __webpack_public_path__ + "img/flot4.32209703.svg";